import AdminTypesPageComponent from "./components/AdminTypesPageComponent";

import axios from "axios";

const fetchTypes = async (abctrl) => {
    const {data} = await axios.get("/api/types", {
        signal: abctrl.signal,
    });
    return data
}

const deleteType = async (userId) => {
    const { data } = await axios.delete(`/api/types/${userId}`);
    return data
}

const AdminTypesPage = () => {
  return <AdminTypesPageComponent fetchTypes={fetchTypes} deleteType={deleteType} />;
};

export default AdminTypesPage;